import { render, staticRenderFns } from "./EditStructure.vue?vue&type=template&id=2d3c28c2&scoped=true&"
import script from "./EditStructure.vue?vue&type=script&lang=ts&"
export * from "./EditStructure.vue?vue&type=script&lang=ts&"
import style0 from "./EditStructure.vue?vue&type=style&index=0&id=2d3c28c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3c28c2",
  null
  
)

export default component.exports